// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type MaterialZwischenInfo } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useDeleteMaterialtransportZwischen(): (
  taetigkeitsberichtId: string,
  fuhrparkeintragId: string,
  zwischenId: string
) => Promise<MaterialZwischenInfo> {
  const getAPI = useGetApi();
  return useCallback(
    async (taetigkeitsberichtId, fuhrparkeintragId, zwischenId) =>
      (await getAPI()).materialtransporte.deleteMaterialtransportZwischen({
        taetigkeitsberichtId,
        fuhrparkeintragId,
        zwischenId,
      }),
    [getAPI]
  );
}
